(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches || typeof Element.prototype.animate !== 'function') return;

  let animation;
  const observer = new MutationObserver(animateTeaser);

  function animateTeaser() {
    const teaser = document.querySelector('.kl-teaser-TsKaak');
    if (!teaser || !teaser.getClientRects().length) return;

    // Klaviyo inserts the teaser asynchronously. Animate only its first appearance.
    observer.disconnect();
    if (reducedMotion.matches) return;
    animation = teaser.animate(
      [
        { transform: 'translateY(0)', offset: 0 },
        { transform: 'translateY(-8px)', offset: 0.35 },
        { transform: 'translateY(0)', offset: 0.7 },
        { transform: 'translateY(0)', offset: 1 }
      ],
      { duration: 1800, iterations: 2, delay: 300, easing: 'ease-in-out' }
    );
    animation.finished.then(cleanup, cleanup);
  }

  function cleanup() {
    reducedMotion.removeEventListener('change', stopForReducedMotion);
  }

  function stopForReducedMotion() {
    if (!reducedMotion.matches) return;
    observer.disconnect();
    if (animation) animation.cancel();
    cleanup();
  }

  reducedMotion.addEventListener('change', stopForReducedMotion);
  observer.observe(document.body, { childList: true, subtree: true, attributes: true });
  animateTeaser();
})();
